import { merge, has } from 'lodash-es'

const messages = []
const callbacks = []
const validMessageTypes = [ "warning", "success", "info", "error", "alert", "notice"]

// Kit Toast defaults (im- design system §14). Positions are gone — every
// toast renders in the single top-right .im-toast-viewport. Hover-pause is
// unconditional in VueToastr, so closeOnHover is no longer a config knob.
const DEFAULT_CONFIG = {
  defaultType: 'info',
  defaultTimeout: 5000,
  defaultClickClose: true,
}

function processObjectData (type, data, title) {
  // if Object
  if (typeof data === 'object' && data.msg) {
    return {
      ...data,
      ...!data.type && { type: DEFAULT_CONFIG.defaultType },
      ...{ type },
      ...title && { title },
      ...!has(data, 'timeout') && { timeout: DEFAULT_CONFIG.defaultTimeout },
      ...!has(data, 'clickClose') && { clickClose: DEFAULT_CONFIG.defaultClickClose },
    }
  }

  // if String
  return {
    msg: data.toString(),
    type: type || DEFAULT_CONFIG.defaultType,
    timeout: DEFAULT_CONFIG.defaultTimeout,
    clickClose: DEFAULT_CONFIG.defaultClickClose,
  }
}

function addMessage (data) {
  if (callbacks.length > 0) {
    callAddCallbacks(data)
  } else {
    messages.push(data)
  }
}

function callAddCallbacks (data) {
  callbacks.forEach((cb) => {
    cb.add(data)
  })
}

function callRemoveCallbacks (data) {
  callbacks.forEach((cb) => {
    cb.remove(data)
  })
}

function registerCallbacks (addCb, removeCb) {
  callbacks.push({
    add: addCb,
    remove: removeCb,
  })

  if (callbacks.length === 1) {
    messages.forEach(callAddCallbacks)
  }
}

function warning (msg, title, data) {
  addMessage(processObjectData('warning', merge(data || {}, { msg: msg }, title)))
}

// Rails `flash[:notice]` is the success channel ("X was successfully
// updated") — it gets the kit's success tone (green bar + check), matching
// the prototype's Users edit flow.
function notice (msg, title, data) {
  addMessage(processObjectData('success', merge(data || {}, { msg: msg }, title)))
}

function info (msg, title, data) {
  addMessage(processObjectData('info', merge(data || {}, { msg: msg }, title)))
}

function error (msg, title, data) {
  addMessage(processObjectData('error', merge(data || {}, { msg: msg }, title)))
}

function success (msg, title, data) {
  addMessage(processObjectData('success', merge(data || {}, { msg: msg }, title)))
}

// Rails `flash[:alert]` carries failures ("not authorized", Devise sign-in
// prompts) — alert tone, not the old neutral info.
function alert (msg, title, data) {
  addMessage(processObjectData('error', merge(data || {}, { msg: msg }, title)))
}

function removeFlash (data) {
  callRemoveCallbacks(data)
}

export default {
  registerCallbacks,
  removeFlash,
  validMessageTypes,
  warning,
  success,
  info,
  error,
  alert,
  notice,
}
